<template>
    <div class="select-calc-mode">

        <criterion-input-radio
            :name="selectMode.name"
            :variants="selectMode.values"
            :selectedValue="mode"

        ></criterion-input-radio>
    </div>
</template>

<script>
    import CriterionInputRadio from './CriterionInputRadio';

    export default {
        data(){
            return {
                selectMode : {
                    id : 'select_mode',
                    name : 'select_mode',
                    inputType : 'radio',
                    values : [
                        {
                            id : 1,
                            value: 'default',
                            text : this.$text.mode.default.title,
                            image: 'https://leto.net.ua/catalog/view/theme/default/template/calculation/img/roof/roofing_heating.png',
                        },
                        {
                            id : 2,
                            value: 'drain',
                            text : this.$text.mode.drain.title,
                            image: 'https://leto.net.ua/catalog/view/theme/default/template/calculation/img/drain/drain_heating.png',

                        },
//                        {
//                            id : 3,
//                            value: 'pavement',
//                            text : this.$text.mode.pavement.title,
//                            image: '',
//                        }
                    ],

                },
            };
        },
        components : {
            CriterionInputRadio,
        },
        computed : {
            mode(){
                return this.$store.getters.getActiveMode
            }
        },
        watch : {
            mode : function () {
                this.$store.dispatch('getSteps');

                if(this.$store.getters.getActiveStepIndex === -1){
                    this.$store.commit('setActiveStepByIndex',0)
                }

                this.$store.dispatch('getCriteria');

            }
        }
    }
</script>

<style>

</style>